import React from "react";
import { Box, Typography } from "@mui/material";
import { CalendarMonth } from "@mui/icons-material";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";

interface SingleDateConfigurationProps {
    timeDateValue: Date | null;
    setTimeDateValue: (val: Date) => void;
    minDate: Date;
    primaryColor: string;
    primaryLightColor: string;
    secondaryColor: string;
    getTranslation: (key: string) => string;
}

const SingleDateConfiguration: React.FC<SingleDateConfigurationProps> = ({
    timeDateValue,
    setTimeDateValue,
    minDate,
    primaryColor,
    primaryLightColor,
    secondaryColor,
    getTranslation,
}) => {
    return (
        <Box
            className="timer-panel-fade-in"
            sx={{
                p: 3,
                backgroundColor: primaryLightColor,
                borderRadius: "12px",
                border: `1px solid ${primaryColor}20`,
                textAlign: "center",
            }}
        >
            <CalendarMonth sx={{ fontSize: 48, color: primaryColor, mb: 1 }} />
            <Typography variant="subtitle2" fontWeight={600} gutterBottom>
                {getTranslation("pm.timer_config.single.title") || "Dettagli Data Singola"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                {getTranslation("pm.timer_config.single.description") || "Seleziona una data specifica per l'esecuzione singola del timer."}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
                <DateTimePicker
                    label={getTranslation("pm.propertyeditor.specificproperties.label.select_date")}
                    viewRenderers={{
                        hours: renderTimeViewClock,
                        minutes: renderTimeViewClock,
                        seconds: renderTimeViewClock,
                    }}
                    slotProps={{
                        textField: {
                            size: "small",
                            helperText:
                                !timeDateValue || isNaN(new Date(timeDateValue).getTime())
                                    ? getTranslation("generic.invalid_data.caption")
                                    : undefined,
                        },
                    }}
                    minDate={dayjs(minDate) as any}
                    value={dayjs(timeDateValue || new Date()) as any}
                    onChange={(value: any) => {
                        if (value !== null) {
                            setTimeDateValue(new Date(value));
                        }
                    }}
                />
            </Box>
        </Box>
    );
};

export default SingleDateConfiguration;
